import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import TabPanel from '@mui/lab/TabPanel';
import SearchBar from "@mkyy/mui-search-bar";
import { toast } from "react-toastify";
import OrderTable from '../../../common/Tables/OrderTable';
import { privateAPI } from '../../../utils/api';
import UserInfo from '../../../common/Dialogs/UserInfo';

const Orders = () => {
  const [loading, setLoading] = useState(true);
  const [allOrders, setAllOrders] = useState([]);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [orderProducts, setOrderProducts] = useState([])
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [orderInfo, setOrderInfo] = useState();

  const getUserById = async (userID) => {
    setLoading(true);
    try {
      const response = await privateAPI.get(`/auth/bacchus/client/user/${userID}`);
      const orderInfo = allOrders.find(item => item.clientId === response.data.id)
      setOrderInfo(orderInfo)
      setUserInfo(response.data);
      setLoading(false);
      setOpenUserInfo(true)
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  const requestSearch = (searchedVal) => {
    const filteredRows = allOrders.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const getAllOrders = async () => {
    setLoading(true);
    try{
        const response = await privateAPI.get(`/auth/bacchus/admin/cart/order`);
        setAllOrders(response.data);
        setRows(response.data);
        setLoading(false);
    } catch (error){
        setLoading(false);
        if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const deleteOrder = async (id) => {
    setLoading(true);
    try{
      await privateAPI.delete(`/auth/bacchus/admin/cart/order/${id}`);
      getAllOrders();
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const updateOrderStatus = async (id, status) => {
    setLoading(true);
    try{
      await privateAPI.put(`/auth/bacchus/admin/cart/order/${id}?status=${status}`);
      getAllOrders();
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const isUserOrderOpen = () => {
    setIsOpen(false);
  }

  const openUserProducts = (orderId) => {
    const order = allOrders.find(order => order.id === orderId);
    setOrderProducts(order.productList);
    setIsOpen(order.id)
  };

  const closeUserInfo = () => {
    setUserInfo({});
    setOpenUserInfo(false);
  };

  useEffect(() => {
    getAllOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TabPanel value="5">
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        style={{ marginBottom: '30px', border: '1px solid #001753', boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)' }}
        />
      <OrderTable 
        orders={rows}
        isOpen={isOpen}
        isUserOrderOpen={isUserOrderOpen}
        deleteOrder={deleteOrder}
        openUserProducts={openUserProducts}
        orderProducts={orderProducts}
        updateOrderStatus={updateOrderStatus}
        open={openUserInfo}
        closeUserInfo={closeUserInfo}
        getUserById={getUserById}
        userInfo={userInfo}
        />
      <UserInfo
        open={openUserInfo}
        closeUserInfo={closeUserInfo}
        userInfo={userInfo}
        orderInfo={orderInfo}
        />
      <Backdrop
        sx={{ color: '#fff', zIndex: 1000 }}
        open={loading}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </TabPanel>
  );
};

export default Orders;
